define('BRListrak.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('BRListrak', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class=\"BRListrak-info\"></section> ";
},"useData":true}, 'extensions/BTM/BRListrak/3.0.0/', 'extensions/BTM/BRListrak/3.0.0/', Handlebars);
});